/**********************************

  wp_fast_ship.js   (Harvest Snaps)

  Cookie helpers + self-heal + early paint + guarded polling auto-trigger.

  ZIP ACQUISITION: assets/worldpantry-ipzipcode.js (boss's proxy) only.
  REMOVED: the exposed IPStack access_key + api.ipstack.com call, the
  global `var zipcode`, geoTarget(), and the setTimeout trigger.

  Harvest Snaps is banner-only (no live inventory). Shipping submit/
  display logic lives in snippets/worldpantry-fast-shipping-logic.liquid,
  which exposes window.wpFsRestore for the early paint below.

***********************************/

var WP_FS = {
  cookies: {
    zip:       'zipcode',
    fsZip:     'FastShip.ZipCode',
    receiveBy: 'FastShip.ReceiveByDateTime',
    orderBy:   'FastShip.OrderByDateTime',
    calcError: 'FastShip.FastShipCalculationError'
  },
  zipInputSelector: '.zip_input',
  formSelector:     'form.js-fs-form'
};

/**********************************
  Cookie functions
***********************************/
function setSessionCookie(name, value) {
  document.cookie = name + "=" + value + "; path=/";     // fixed: was "; ; path=/"
}

function getSessionCookie(name) {
  var nameKey = name + "=";
  var cDecoded = decodeURIComponent(document.cookie);
  var cArr = cDecoded.split("; ");
  var res;
  cArr.forEach(function (val) {
    if (val.indexOf(nameKey) === 0) res = val.substring(nameKey.length);
  });
  return res;
}

function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  var result = null;
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(nameEQ) === 0) result = decodeURIComponent(c.substring(nameEQ.length));
  }
  return result;
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value != null ? value : "") + expires + "; path=/";
}

function isValidZip(str) {
  return /^\d{5}(-\d{4})?$/.test(str || "");
}

/**********************************
  Self-heal (No Error / legacy formatted date cookies)
***********************************/
(function selfHealFastShipCookies() {
  var err = getSessionCookie(WP_FS.cookies.calcError);
  if (err) {
    var zip = getSessionCookie(WP_FS.cookies.fsZip);
    if (err === "No Error" || !isValidZip(zip)) deleteCookie(WP_FS.cookies.calcError);
  }
  var receiveBy = getSessionCookie(WP_FS.cookies.receiveBy);
  var orderBy = getSessionCookie(WP_FS.cookies.orderBy);
  // Raw ISO contains "T"; the old formatDate stored strings like "August 11".
  if ((receiveBy && receiveBy.indexOf("T") === -1) ||
      (orderBy && orderBy.indexOf("T") === -1)) {
    deleteCookie(WP_FS.cookies.receiveBy);
    deleteCookie(WP_FS.cookies.orderBy);
  }
})();

/**********************************
  Auto-trigger: early paint + first-visit poll (guarded).
***********************************/
(function wpFsAutoTrigger() {
  if (window.wpFsAutoInit) { return; }
  window.wpFsAutoInit = true;

  var jqWaits = 0;
  function whenReady() {
    if (typeof window.jQuery === 'undefined') {
      if (jqWaits++ < 50) { setTimeout(whenReady, 100); }
      return;
    }
    window.jQuery(function ($) {
      if (typeof window.wpFsRestore === 'function') {
        try { window.wpFsRestore(); } catch (e) {}
      }

      if (getSessionCookie(WP_FS.cookies.fsZip) && getSessionCookie(WP_FS.cookies.receiveBy)) {
        console.log("FastShip data already exists, skipping auto lookup");
        return;
      }

      var attempts = 0;
      function tryAutoLookup() {
        var zip = getCookie(WP_FS.cookies.zip);
        if (isValidZip(zip)) {
          console.log("fast geo zip " + zip);
          $(WP_FS.zipInputSelector).val(zip);
          $(WP_FS.formSelector).first().submit();
          return;
        }
        if (attempts++ < 20) { setTimeout(tryAutoLookup, 200); }
        else { console.log("no valid zipcode after waiting - giving up auto lookup"); }
      }
      tryAutoLookup();
    });
  }
  whenReady();
})();
